// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueProgressBar from 'vue-progressbar'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination, Lazy } from 'swiper'
import { VueReCaptcha } from "vue-recaptcha-v3";


import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.scss'

// css and scss files include
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/font-awesome.min.css'
import './assets/index.scss'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

// remove below file for change color
// import './assets/css/color/color-2.css'
SwiperCore.use([Autoplay, EffectFade, Navigation, Pagination, Lazy])
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(vueVimeoPlayer)
Vue.config.productionTip = false
Vue.use(VueReCaptcha, { siteKey: "6LeXgKcUAAAAADmANKD2VkOpFM1MhgNHaDQ6vUjL" });

const options = {
    color: '#7DEADF',
    failedColor: '#7DEADF',
    thickness: '4px',
    transition: {
        speed: '0.5s',
        opacity: '0.10s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}
Vue.use(VueProgressBar, options)
Vue.use(VueAwesomeSwiper)

export const vues = new Vue()
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js